import { deserialize, LEGACY_KEY, PREVIOUS_KEY, readSave, SAVE_KEY, serialize } from './persistence';
type StorageLike = Pick<Storage, 'getItem' | 'setItem'>;
let account: string | null = null;
const userKey = (key: string) => `verdant-isles:account:v3:${key}`;
export const activeSaveKeys = () => account ? [userKey(account)] : [SAVE_KEY, PREVIOUS_KEY, LEGACY_KEY];
export const activeSaveKey = () => activeSaveKeys()[0];
function snapshot(source: StorageLike, keys: string[]) {
  const world = readSave(source, keys);
  return world ? JSON.parse(serialize(world)) as Record<string, unknown> : null;
}
export function createAccountAdapter(source: StorageLike, before: () => void, changed: () => void) {
  return {
    setAccount(key: string | null) {
      const next = key && /^[\w-]{43}$/.test(key) ? key : null;
      if (next !== account) { before(); account = next; changed(); }
    },
    captureGuest: () => snapshot(source, [SAVE_KEY, PREVIOUS_KEY, LEGACY_KEY]),
    captureAccount: (key: string) => key === account ? snapshot(source, [userKey(key)]) : null,
    restoreAccount(payload: unknown, key: string) {
      if (key !== account || !payload || typeof payload !== 'object') throw new Error('Stale account or invalid garden');
      const world = deserialize(JSON.stringify(payload));
      if (!world) throw new Error('Unsupported garden version');
      before();
      const previous = source.getItem(userKey(key));
      if (previous) source.setItem(userKey(key) + ':before-restore', previous);
      source.setItem(userKey(key), serialize(world)); changed();
    },
    describe: (payload: Record<string, unknown>) => `庭园第 ${payload.day} 日，${Array.isArray(payload.companions) ? payload.companions.length : 0} 位伙伴。远征加载安全返回庭园，不恢复战斗或未领取奖励。`,
  };
}
declare global { interface Window { FribenchAccount?: { connectStorage(adapter: ReturnType<typeof createAccountAdapter>): Promise<void> } } }
export function connectAccountStorage(before: () => void, changed: () => void) {
  const connect = () => { try { if (window.FribenchAccount) void window.FribenchAccount.connectStorage(createAccountAdapter(localStorage, before, changed)); } catch { /* Local play remains available. */ } };
  window.addEventListener('fribench:ready', connect); connect();
}
